module.exports = __webpack_public_path__ + "img/1715650163739-WhatsApp Image 2024-05-14 at 09.14.39.jpeg.7ff97feb.webp";